export default __webpack_public_path__ + "static/media/0020.e2fd399f.png";